import { render, staticRenderFns } from "./GameBuilderView.vue?vue&type=template&id=94a09ec2&"
import script from "./GameBuilderView.vue?vue&type=script&lang=js&"
export * from "./GameBuilderView.vue?vue&type=script&lang=js&"
import style0 from "./GameBuilderView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports